import type { AxiosError } from 'axios';

export const useApiError = (error: unknown): string | null => {
  if (!error) return null;

  const axiosError = error as AxiosError<{
    error?: { code?: string; message?: string };
    message?: string;
  }>;
  return (
    axiosError.response?.data?.error?.message ??
    axiosError.response?.data?.message ??
    axiosError.message ??
    'An unexpected error occurred'
  );
};
